import React from 'react';
import './loader.scss';

const Loader = () => {
  return (
    <div className="loader">
      <div className="loadingio-spinner-cube-vhqvuddsw0l">
        <div className="ldio-5bfehwmxebb">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
